var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"sellers@c42e6d297fd4fc8b438ad8ccffc255ae7bd3c9f3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sellers@riqra-pp"]={id:"sellers@c42e6d297fd4fc8b438ad8ccffc255ae7bd3c9f3"};
      